const container = "_35sc1mmyov7";
const content = "_35sc169jotu";
const headerAndPie = "_35shrzrhag";
const tasksWrapper = "_35st539m2p";
const tasksContainer = "_35stvs7wsu";
const taskAccordionsHeader = "_35st9jx5nk";
const taskAccordions = "_35str80gkh";
const pieChart = "_35sp1ue4gku";

export { container, content, headerAndPie, pieChart, taskAccordions, taskAccordionsHeader, tasksContainer, tasksWrapper };
import "./_page.results.style.linaria.module.css";
//# sourceMappingURL=_page.results.style.js.map
